/* @ngInject */
export default function ($scope, AuthService, StaffReportsAdverseEventsService, DataTablesService, LayoutService, STATUSES, $timeout, toastr, StatusService, Reports) {
	AuthService.redirectIfUnauthorized('aac-management', 'splash.home');

	LayoutService.setTitle('Management');
	LayoutService.getPageHeader()
	             .setBreadcrumbs([
		             {
			             route:       'staff.dashboard',
			             displayName: 'Dashboard',
		             },
		             {
			             route:       null,
			             displayName: 'Reports',
		             },
		             {
			             route:       'staff.reports.management.root',
			             displayName: 'Management',
		             },
	             ]);

	$scope.loading = true;

	$scope.refresh = () => {
		$scope.loading = true;
		Reports.getList()
		       .then((response) => {
			       $scope.reports = response;
			       $scope.loading = false;

		       })
		       .catch((error) => {
			       $scope.status  = STATUSES.ERRORED;
			       $scope.loading = false;

		       });
	};

	$scope.refresh();
}


// WEBPACK FOOTER //
// ./src/js/endpoints/staff/reports/management/root/controller.js